import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CTASection = () => {
  const handleWhatsAppDemo = () => {
    window.dispatchEvent(
      new CustomEvent("open-chat", {
        detail: { message: "Quiero ver la demo por WhatsApp" },
      })
    );
  };

  return (
    <section data-testid="cta-section" className="py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="relative bg-primary rounded-[2rem] p-10 md:p-16 overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />

          <div className="relative text-center max-w-xl mx-auto">
            <h2
              data-testid="cta-title"
              className="text-3xl md:text-4xl font-bold text-primary-foreground tracking-tight mb-4"
            >
              ¿Quieres ver cómo sería en tu clínica?
            </h2>
            <p className="text-primary-foreground/80 text-base md:text-lg mb-8 leading-relaxed">
              Agenda una reunión y te mostramos cómo se integra el asistente
              en tu clínica real. Sin compromiso.
            </p>
            <Button
              data-testid="cta-whatsapp-btn"
              onClick={handleWhatsAppDemo}
              className="rounded-full px-8 h-12 text-base font-medium bg-white text-primary hover:bg-white/90 shadow-lg hover:shadow-xl transition-shadow"
            >
              <MessageSquare className="w-4 h-4 mr-2" strokeWidth={1.5} />
              Ver demo WhatsApp (en la reunión)
            </Button>
            <p className="text-primary-foreground/70 text-sm mt-4">
              En la reunión te daremos un número de prueba y un código para que puedas probar el WhatsApp desde tu propio móvil.
            </p>
            <p className="text-primary-foreground/45 text-xs mt-1.5">
              No necesitas instalar nada. Solo WhatsApp.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
